<template>
  <iframe
    :class="[width, height]"
    class="rounded-2.5xl"
    v-bind="$props"
  >
  </iframe>
</template>

<script setup>

defineOptions({
  name: 'AtomsVideoFrame'
})

defineProps({
  src: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  allow: {
    type: String,
    default: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
  },
  allowfullscreen: {
    type: String,
    default: 'allowfullscreen'
  },
  width: {
    type: String,
    default: 'w-full'
  },
  height: {
    type: String,
    default: 'lg:h-[32rem] h-56'
  }
})

</script>

<style scoped>

</style>
